// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__2GPg1","text":"SelectPayment_text__1s355","title":"SelectPayment_title__1mfr2","btn":"SelectPayment_btn__22AlR"};